module.exports = {"title":"Lecturas","azName":"Azimut / Manteo *","qdName":"Rumbo / Manteo","ddName":"Dir. Manteo / Manteo","azTooltip":"* De acuerdo a la regla de la mano derecha."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/readings/es/messages.json
// module id = 155
// module chunks = 0